import {TranslocoService} from '@ngneat/transloco'
import {Injectable} from '@angular/core'
import {DialogService} from '../../../craft/dialog/dialog.service'
import {LinkService} from '../../../core/i18n/link.service'
import {take} from 'rxjs/operators'
import {ApplicationRoute} from '../../../craft/utils/application.route'
import {CalculatorCloseConfirmationComponent} from './calculator-navbar/calculator-close-confirmation.component'

@Injectable()
export class CalculatorsService {
  constructor(
    private readonly dialogService: DialogService,
    private readonly linkService: LinkService,
    private readonly translocoService: TranslocoService,
  ) {}

  get erneuerbarheizenLanguage(): string {
    // Note: there is no english translation for erneuerbarheizen
    // the calculator should not be linked anywhere for english
    switch (this.translocoService.getActiveLang()) {
      case 'de':
        return 'de'
      case 'fr':
        return 'fr'
      case 'it':
        return 'it'

      default:
        // we'll just default to an empty string in order for the page to not look broken as the calculator will default to its default langauge
        // at time of writing that would be german
        return ''
    }
  }

  close(exitButtonText: string): void {
    this.dialogService
      .show(CalculatorCloseConfirmationComponent, exitButtonText)
      .closed.pipe(take(1))
      .subscribe(result => {
        if (result) {
          this.linkService.navigateTo(new ApplicationRoute(this.linkService.previousPage || this.linkService.homePath))
        }
      })
  }
}
